const premiumFeatureWrapperStyles = {
  wrapper: {
    position: "relative",
    width: "100%",
  },
  blurContainer: {
    filter: "blur(5px)",
    pointerEvents: "none",
    userSelect: "none",
    overflow: "hidden",
    width: "100%",
    height: "calc(100vh - 263px)",
  },
  overlayContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center", // Changed from flex-end to center
    backgroundColor: "rgba(255, 255, 255), 0.4)", // Added more opacity for better visibility
    zIndex: 1,
    width: "100%",
    overflow: "hidden",
  },
  contentBox: {
    background: "rgba(0, 0, 0, 0.7)", // Changed from gradient to solid background
    padding: "30px",
    width: "100%",
    maxWidth: "600px", // Added max-width for better appearance
    textAlign: "center",
    borderRadius: "8px", // Added border radius
  },
  messageText: {
    color: "white",
    mb: 2,
    textAlign: "center",
  },
  upgradeButton: {
    maxWidth: "fit-content",
  },
} as const;

export default premiumFeatureWrapperStyles;
